// extracted by mini-css-extract-plugin
module.exports = {"backButtonMain":"BackButton_backButtonMain__1m_oK","backButton":"BackButton_backButton__18SxD"};